<template>
  <v-form class="asc-role-dialog-form">
    <v-container class="pa-0 mb-4 asc-role-dialog-container" fluid>
      <v-row no-gutters>
        <v-col cols="3" class="pr-3">
          <asc-text-field-input
            v-model="newRoleDetails.fields.name"
            label="Role Name"
            placeholder="Role Name"
            :counter="true"
            :max-length="45"
            required
            :rules="newRoleDetails.rules.name"
          />
        </v-col>
        <v-col cols="">
          <asc-text-field-input
            v-model="newRoleDetails.fields.description"
            label="Description"
            placeholder="Description"
            :counter="true"
            :max-length="100"
            :rules="newRoleDetails.rules.description"
            required
          />
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import AscTextFieldInput from '@/components/atoms/AscTextFieldInput'
import _ from 'lodash'

export default {
  name: 'AscRoleDialogForm',

  components: {
    AscTextFieldInput,
  },

  props: {
    role: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      newRoleDetails: {
        fields: {
          name: '',
          description: '',
        },
        rules: {
          name: [v => !!v || 'Name is required'],
          description: [v => !!v || 'Description is required'],
        },
      },
    }
  },

  watch: {
    newRoleDetails: {
      deep: true,
      handler() {
        this.$emit('input', _.omit(this.newRoleDetails, ['rules']))
      },
    },
    role: {
      deep: true,
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.newRoleDetails.fields = { ...newValue }
        }
      },
    },
  },
}
</script>

<style lang="scss"></style>
